
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support-report",
      function () {
        return require("private-next-pages/support-report.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support-report"])
      });
    }
  